import { render, staticRenderFns } from "./customInfoDetails.vue?vue&type=template&id=e34a81ce&"
import script from "./customInfoDetails.vue?vue&type=script&lang=js&"
export * from "./customInfoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports